var map = {
	"./animation-key.gif": 234,
	"./animation-key2.gif": 235,
	"./animation-key3.gif": 236,
	"./background-info.svg": 237,
	"./background-intro.jpg": 238,
	"./background-login-bottom.svg": 239,
	"./background-login-top.svg": 240,
	"./background-login.svg": 241,
	"./background-night.svg": 242,
	"./background-splash-bottom.svg": 243,
	"./background-splash-middle.svg": 244,
	"./background-splash-top.svg": 245,
	"./background-the-end.svg": 246,
	"./button-info-hover.svg": 247,
	"./button-info.svg": 248,
	"./button-login-hover.svg": 249,
	"./button-login.svg": 250,
	"./button-menu-hover.svg": 251,
	"./button-menu.svg": 252,
	"./button-play-hover.svg": 253,
	"./button-play.svg": 254,
	"./cards/feedback.svg": 78,
	"./cards/mission.svg": 138,
	"./decks/blue-back.svg": 255,
	"./decks/blue-deck.svg": 256,
	"./decks/pink-back.svg": 257,
	"./decks/pink-deck.svg": 258,
	"./flower1.svg": 259,
	"./flower2.svg": 260,
	"./icon-arrow-down.svg": 261,
	"./icon-check.svg": 262,
	"./icon-close.svg": 139,
	"./icon-eye.svg": 263,
	"./icon-info.svg": 264,
	"./icon-labyrinth.svg": 265,
	"./icon-loading-key.svg": 266,
	"./icon-loading.svg": 267,
	"./icon-sortable.svg": 268,
	"./logo-cgl.png": 269,
	"./logo-region-s.png": 270,
	"./logo-tryg.png": 271,
	"./mazes/key-horizontal-ghost.svg": 140,
	"./mazes/key-horizontal-unlocked.svg": 141,
	"./mazes/key-horizontal.svg": 142,
	"./mazes/key-rotated-unlocked.svg": 143,
	"./mazes/key-rotated.svg": 144,
	"./mazes/key-vertical-ghost.svg": 145,
	"./mazes/key-vertical-unlocked.svg": 146,
	"./mazes/key-vertical.svg": 147,
	"./mazes/maze-1.svg": 148,
	"./mazes/maze-2.svg": 149,
	"./mazes/maze-3.svg": 150,
	"./portal/background-ground.svg": 272,
	"./portal/background-portal-1.svg": 273,
	"./portal/background-portal-2.svg": 274,
	"./portal/background-portal-3.svg": 275,
	"./portal/background-portal-4.svg": 276,
	"./portal/background-portal-5.svg": 277,
	"./portal/gate.svg": 278,
	"./portal/key-hole-unlocked.svg": 279,
	"./portal/key-hole.svg": 280,
	"./portal/maze-left.svg": 281,
	"./portal/maze-right.svg": 282,
	"./progress/icon-moon.svg": 283,
	"./progress/icon-moon2.svg": 284,
	"./progress/icon-sun.svg": 285,
	"./progress/maze-floor.svg": 286,
	"./progress/maze-portal.svg": 287,
	"./stats/heart-filled.svg": 288,
	"./stats/heart.svg": 289,
	"./stats/shield-filled.svg": 290,
	"./stats/shield.svg": 291,
	"./stats/sun-filled.svg": 292,
	"./stats/sun.svg": 293,
	"./stats/water-filled.svg": 294,
	"./stats/water.svg": 295,
	"./surveys/therapist-2.svg": 151,
	"./surveys/therapist.svg": 152,
	"./title.svg": 296
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 233;